export enum RewardsProgramSchemes {
  Flybuys = 'Flybuys',
  Bnz = 'Bnz',
}

export enum RewardsProgramTransferConnectIdentifier {
  Flybuys = 'FLYBUYS',
  Uber = 'UBER',
  Bnz = 'BNZ',
}
